import i18n from 'i18n-js';

import C from '../constants';

const { PHOTOAI } = C.AFILIATES;

export const FORTNITE_TEMPLATES_TITLES = {
  COUNTDOWN_FORTNITEBUS: 'countdown-fortnitebus',
  COUNTDOWN_FORTNITEISLAND: 'countdown-fortniteisland',
  COUNTDOWN_FORTNITELLAMA: 'countdown-fortnitellama',
  FORTNITE_SIMPLE: 'fortnite-simple',
};

export const FORTNITE_TEMPLATES_IMAGES = {
  [FORTNITE_TEMPLATES_TITLES.COUNTDOWN_FORTNITEBUS]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-fortnitebus-1.webp',
  [FORTNITE_TEMPLATES_TITLES.COUNTDOWN_FORTNITEISLAND]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-fortniteisland-1.webp',
  [FORTNITE_TEMPLATES_TITLES.COUNTDOWN_FORTNITELLAMA]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-fortnitellama-1.webp',
  [FORTNITE_TEMPLATES_TITLES.FORTNITE_SIMPLE]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/fortnite-simple-1.webp',
};

export const FORTNITE_TEMPLATES = {
  fortnite: [
    {
      category: i18n.t('screens.templates.fortnite.title'),
      description: i18n.t('screens.templates.fortnite.simple.description'),
      shortDescription: i18n.t(
        'screens.templates.fortnite.simple.shortDescription'
      ),
      id: FORTNITE_TEMPLATES_TITLES.FORTNITE_SIMPLE,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/fortnite-simple-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/fortnite-simple-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/fortnite-simple-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/fortnite-simple-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.fortnite.simple.title'),
      users: 2185,
    },
    {
      category: i18n.t('screens.templates.countdown.title'),
      description: i18n.t(
        'screens.templates.fortnite.countdownllama.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.fortnite.countdownllama.shortDescription'
      ),
      id: FORTNITE_TEMPLATES_TITLES.COUNTDOWN_FORTNITELLAMA,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-fortnitellama-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-fortnitellama-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-fortnitellama-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-fortnitellama-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.fortnite.countdownllama.title'),
      users: 1805,
    },
    {
      category: i18n.t('screens.templates.countdown.title'),
      description: i18n.t(
        'screens.templates.fortnite.countdownbus.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.fortnite.countdownbus.shortDescription'
      ),
      id: FORTNITE_TEMPLATES_TITLES.COUNTDOWN_FORTNITEBUS,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-fortnitebus-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-fortnitebus-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-fortnitebus-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-fortnitebus-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.fortnite.countdownbus.title'),
      users: 728,
    },
    {
      category: i18n.t('screens.templates.countdown.title'),
      description: i18n.t(
        'screens.templates.fortnite.countdownisland.description'
      ),
      shortDescription: i18n.t(
        'screens.templates.fortnite.countdownisland.shortDescription'
      ),
      id: FORTNITE_TEMPLATES_TITLES.COUNTDOWN_FORTNITEISLAND,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-fortniteisland-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-fortniteisland-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-fortniteisland-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-fortniteisland-4.webp',
      ],
      link: PHOTOAI,
      title: i18n.t('screens.templates.fortnite.countdownisland.title'),
      users: 1419,
    },
  ],
};

export default {
  FORTNITE_TEMPLATES,
  FORTNITE_TEMPLATES_IMAGES,
  FORTNITE_TEMPLATES_TITLES,
};
